import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import api from '../services/api'

export const useAccountStore = defineStore('account', () => {
  /** @type Ref<Account> **/
  const account = ref({})
  const credits = ref({})
  /** @type Ref<MigrationStatus> **/
  // const migrationStatus = ref({})
  const currentSubscription = ref(null)
  const appsumoDeal = computed(() => account.value?.appsumo?.tier ? appsumoDeals[account.value.appsumo.tier] : null)


  async function loadAccount (refresh) {
    if (account.value?.id && !refresh) {
      return
    }
    const acct = await api.getAccount()
    if (!acct) {
      console.error('MyAccount could not be loaded')
      return false
    }
    account.value = acct
    await reloadCredits()
    // await reloadMigrationStatus()
    if (account.value.paddleBilling?.lastSubscription) {
      currentSubscription.value = JSON.parse(account.value.paddleBilling.lastSubscription)
    }
    return true
  }
  async function reloadCredits() {
    credits.value = await api.getAccountCredits(account.value.id)
  }
  // async function reloadMigrationStatus() {
  //   migrationStatus.value = await api.getMigrationStatus()
  // }
  void loadAccount()
  function $reset() {
    account.value = {}
    credits.value = {}
    // migrationStatus.value = {}
    currentSubscription.value = null
  }
  async function reload() {
    await loadAccount(true)
  }

  async function updateSubscription(subscription) {
    const res = await api.updateSubscription(subscription, false)
    if  (res.action === 'subscription_canceled') {
      account.value.paddleBilling = {}
      currentSubscription.value = null
    } else if (res.action === 'subscription_updated') {
      account.value.paddleBilling.lastSubscription = JSON.stringify(res.subscription)
      currentSubscription.value = res.subscription
    }
    return res
  }

  const appsumoDeals = {
    1: {
      tier: 1,
      creditsPerMonth: 300,
      powerUpWorkspaces: 1,
      bonusLifetimeCredits: 1000,
      bonusFileStorage: 0,
      discountCreditsPrice: false
    },
    2: {
      tier: 2,
      creditsPerMonth: 900,
      powerUpWorkspaces: 3,
      bonusLifetimeCredits: 2000,
      bonusFileStorage: 1,
      discountCreditsPrice: false
    },
    3: {
      tier: 3,
      creditsPerMonth: 1500,
      powerUpWorkspaces: 5,
      bonusLifetimeCredits: 3000,
      bonusFileStorage: 2,
      discountCreditsPrice: 7

    },
    4: {
      tier: 4,
      creditsPerMonth: 5000,
      powerUpWorkspaces: 10,
      bonusLifetimeCredits: 4000,
      bonusFileStorage: 3,
      discountCreditsPrice: 7
    },

  }

  return {
    $reset,
    account,
    credits,
    // migrationStatus,
    reload,
    loadAccount,
    currentSubscription,
    updateSubscription,
    reloadCredits,
    appsumoDeal
  }
})

/**
 * @typedef MigrationStatus
 * @property {string} accountId - the accountId(=userId)
 * @property {string?} created - the time that the migration status was created ISO formatted
 * @property {string?} updated - the last time which the migration status was updated ISO formatted
 * @property {boolean} v1User - whether this user has an account in v1
 * @property {boolean} v2User - whether this user has an account in v2
 * @property {'NA','NOT_STARTED'|'STARTED'|'DONE'} status - NA=migration is not relevant since v1User is false
 **/

/**
 * @typedef Account
 * @property {string} uid - userId that owns this account
 * @property {string} id - commonly the same as userId, but should not count on it
 * @property {string} created - the time which the account was created ISO formatted
 * @property {string} updated - the last time which the account was updated ISO formatted
 * @property {string} email of the owner user
 * @property {Object} autoRecharge - auto-recharge settings
 * @property {boolean} autoRecharge.enabled - is auto-recharge enabled
 * @property {number} autoRecharge.threshold - lower limit that triggers the auto-recharge
 * @property {number} autoRecharge.creditsQuantity - number of credits to purchase when auto-recharge is triggered
 * @property {object=} paddleBilling
 * @property {string=} paddleBilling.subscriptionId - id of subscription, if exists. Prefixed with 'sub_'
 * @property {string=} paddleBilling.customerId - if of customer, if exists. Prefixed with 'ctm_'
 * @property {string=} paddleBilling.lastSubscription - stringified json that describes the latest paddle billing.
 * @property {Object} workspaceAddons - keys are workspaceIds, and values are objects with entries addon:boolean
 */

/**
 * @typedef Subscription
 * TODO
 */
